import { useSearchParams } from "react-router";

const PARAM = "projects";

// Same reasoning as the snippets catalog's identical hook: the URL is the source of truth, not
// React state, so the filter survives a refresh and is shareable/bookmarkable. Kept as its own
// small copy under this page rather than importing snippets' `_components` (page-private by
// convention), same choice already made for the SEO page.
export function useSelectedProjectIds(): [string[], (projectIds: string[]) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedProjectIds = searchParams.get(PARAM)?.split(",").filter(Boolean) ?? [];

  const setSelectedProjectIds = (projectIds: string[]) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (projectIds.length === 0) {
          next.delete(PARAM);
        } else {
          next.set(PARAM, projectIds.join(","));
        }
        return next;
      },
      { replace: true }
    );
  };

  return [selectedProjectIds, setSelectedProjectIds];
}
